import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";

import { _staffSpecialist, _toastVariants, FILE_UPLOAD_DIR } from "../../../utils/Constant";
import { useFormik } from "formik";
import { showMessage } from "../../../utils/toast/globalToast";
import { formatFileURL, getFileUrl, uploadFile, validateDocumentFileType, validateImageFileType } from "../../../utils/helper/appHelpers";
import { LoadingButton } from "@mui/lab";
import { apiRequest } from "../../../utils/config/apiRequest";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import { _vendorAdminRoutes } from "../../../utils/appRouter";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import CustomSelectFile from "../../../comman/CustomSelectFile";
import { fetchStaffDetail } from "../../../store/slices/staffSlice";
import { fetchShopList } from "../../../store/slices/shopSlice";

const AddEditStaff = () => {

  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { shopListing} = useSelector((state) => state.shops);

  const { staffDetail: { data: staffData } } = useSelector((state) => state.staff);

  const { staffId } = useParams()

  useEffect(() => {
    if (!staffId) return;  
    dispatch(fetchStaffDetail(staffId))
  }, [])

useEffect(() => {
  dispatch(fetchShopList({ paginate: '' }));
}, [dispatch]);


  const initialValues = {
    id: staffData?._id || '',
    shopId: '', 
    level: "",
    specialistServices: [],
    userName: "",
    profilePic: '',
    email: "",
    dialCode: "+971",
    mobileNo: '',
    gender: '',
    statusupdate: "ACTIVE",
    documents: [
      {
        name: "",
        attachments: [],
        expiryDate: ""
      }
    ],
    vehicleRegNo : '',
    drivingLicense : '',
    isDeliveryAssociate : false
  }


  const validationSchema = Yup.object().shape({
    level: Yup.string().required("Level is required"),

    specialistServices: Yup.array()
      .min(1, "At least one specialist service is required"),

    userName: Yup.string()
      .trim()
      .required("Full name is required"),

    // profilePic: Yup.mixed()
    //   .required("Profile Pic is required"),

    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),

    // dialCode: Yup.string()
    //   .required("Dial code is required"),

    mobileNo: Yup.string().required("Mobile is required"),

    gender: Yup.string()
      .required("Gender is required"),

    shopId: Yup.string().required("Branch is required"),


    // documents: Yup.array().of(
    //   Yup.object().shape({
    //     name: Yup.string().required("Document name is required"),
    //     attachments: Yup.array()
    //       .min(1, "Please upload at least one document"),
    //     expiryDate: Yup.date()
    //       .required("Expiry date is required")
    //       .min(new Date(), "Expiry date must be in the future")
    //   })
    // )
    // documents: Yup.array()
    //   .min(1, "At least one document is required")
    //   .required("Documents are required")
    //   .test(
    //     "all-document-fields-required",
    //     "All document fields are required",
    //     function (value) {
    //       if (!value || value.length === 0) return false;

    //       return value.every(
    //         (doc) =>
    //           doc.type &&
    //           doc.type.trim() !== "" &&
    //           doc.expiryDate &&
    //           doc.expiryDate.trim() !== "" &&
    //           Array.isArray(doc.attachments) &&
    //           doc.attachments.length > 0
    //       );
    //     }
    //   ),
  });



  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        // ✅ Upload registration documents
        const uploadedDocs = await Promise.all(
          values.documents.map(async (doc) => {
            const uploadedFiles = await Promise.all(
              (doc.attachments || []).map(async (file) => await uploadFile(file, FILE_UPLOAD_DIR.STAFF))
            );
            return {
              ...doc,
              attachments: uploadedFiles, // replace file objects with uploaded URLs
            };
          })
        );
        const payload = {
          userName: values.userName,
          email: values.email,
          gender: values.gender,
          dialCode: values.dialCode,
          mobileNo: values.mobileNo,
          profilePic: values.profilePic,
          status: values.statusupdate,
          shopId: values.shopId, 
          staffInfo: {
            level: values.level,
            specialistServices: values.specialistServices,
            documents: uploadedDocs
          },
          riderInfo :{  
              vehicleRegNo : values.vehicleRegNo, 
              drivingLicense : values.drivingLicense
          }
        }

        //URL for Images
        if (typeof values.profilePic !== "string") {
          const formData = new FormData()
          formData.append('file', values.profilePic);

          let { data, status } = await apiRequest({
            method: "POST",
            endUrl: apiUrl.uploadFile(FILE_UPLOAD_DIR.STAFF),
            body: formData,
            headerType: 'form'
          });

          if (status) {
            payload.profilePic = data?.shortUrl
          }
        }
        else {
          delete payload.profilePic;
        }


        const { data, status } = await apiRequest({
          endUrl: apiUrl.staff.userStaff,
          method: staffData?._id ? "PUT" : "POST",
          params: staffData?._id ? { staffId: staffData?._id } : null,
          body: payload,
          showMsg: true
        });

        if (status) {
          navigate(_vendorAdminRoutes.staff.list)
        }

      } catch (error) {
        console.log('error', error)
      } finally {
        setIsLoading(false);
      }
    }
  });


  useEffect(() => {

    if (staffData?._id && shopListing?.rows?.length) {
      const matchedShop = shopListing.rows.find(
        (shop) => shop?._id === staffData?.branchInfo[0]?.shopId?._id
      )

      setValues({
        ...values,
        shopId: matchedShop ? matchedShop._id : " ",
        level: staffData?.staffInfo?.level || '',
        specialistServices: staffData?.staffInfo?.specialistServices || [],
        userName: staffData?.userName || '',
        profilePic: staffData?.profilePic || '',
        email: staffData?.email || '',
        dialCode: staffData?.dialCode || '',
        mobileNo: staffData?.mobileNo || '',
        gender: staffData?.gender || '',
        statusupdate: staffData?.status || 'ACTIVE',
        documents: staffData?.staffInfo?.documents?.map((item) => ({
          name: item?.name || "",
          attachments: item?.attachments || [],
          expiryDate: item?.expiryDate || ""
        })) || [],
        vehicleRegNo : staffData.riderInfo?.vehicleRegNo || '', 
        drivingLicense : staffData.riderInfo?.drivingLicense || '',
        isDeliveryAssociate:staffData?.isRider || ''
      })
    }
  }, [staffData, shopListing]);

  const { values, handleChange, setFieldValue, touched, errors, handleSubmit, setValues } = formik;


  return (
    <section className="content mb-5">
      <form >
        <div className="container-fluid">
          <div className="row titlepad publsih-sticky">
            <div className="col-md-12">
              <div className="mt-3 mb-3">
                <div className="dashbed-border-bottom"></div>
              </div>
              <div className="row">
                <div className="col-sm-8">
                  <h4>Staff Detail</h4>
                  <p className="page-sub-head">{staffData?._id ? "Edit" : "Add"} Staff Detail </p>
                </div>
                <div className="col-md-4 text-sm-right mt-2">

                  <button
                    onClick={handleSubmit}
                    className="btn-md px-3 py-2 btn-primary"
                  >
                    <i className="fa-regular fa-square-check" aria-hidden="true"></i>{" "}
                    {isLoading
                      ? staffData?._id
                        ? "Updating..."
                        : "Publishing..."
                      : staffData?._id
                        ? "Update"
                        : "Publish"}

                  </button>
                  <a
                    href={_vendorAdminRoutes.staff.list}
                    className="btn-md px-3 py-2 btn-secondary"
                  >
                    <i className="fa fa-chevron-circle-left"></i> Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <div className="tabData mt-4">
                <h6>Enter the details below for create staff</h6>
                <div className="mt-2 mb-2">
                  <div className="dashbed-border-bottom"></div>
                </div>
                <div className="pb-4">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Level <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control selectpicker"
                          name="level"
                          onChange={handleChange}
                          value={values.level}
                        >
                          <option value="">Select </option>
                          {_staffSpecialist.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}

                        </select>
                        {touched?.level && errors?.level ? (
                          <span style={{ fontSize: '14px', color: 'red' }}>{errors?.level}</span>
                        ) : ''}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Specialist Services{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          isMulti
                          options={_staffSpecialist}
                          value={values.specialistServices}
                          name="specialistServices"
                          onChange={(selectedOptions) =>
                            setFieldValue("specialistServices", selectedOptions)
                          }
                          placeholder="Select Specialist Services..."
                        />
                        {touched?.specialistServices && errors?.specialistServices ? (
                          <span style={{ fontSize: '14px', color: 'red' }}>{errors?.specialistServices}</span>
                        ) : ''}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Full Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Full Name"
                          name="userName"
                          value={values.userName}
                          onChange={handleChange}
                        />
                        {touched?.userName && errors?.userName ? (
                          <span style={{ fontSize: '14px', color: 'red' }}>{errors?.userName}</span>
                        ) : ''}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Email ID <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Email ID"
                          name="email"
                          onChange={handleChange}
                          value={values.email}
                        />
                        {touched?.email && errors?.email ? (
                          <span style={{ fontSize: '14px', color: 'red' }}>{errors?.email}</span>
                        ) : ''}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Mobile No.<span className="text-danger">*</span>
                        </label>
                        <div className="mobile-input-wrapper">

                          <div className="country-code">
                            <select
                              onChange={handleChange}
                              name='dialCode'
                              value={values.dialCode}
                            >
                              <option defaultValue value={"+1"}>+1</option>
                              <option value={"+91"}>+91</option>
                              <option value={"+44"}>+44</option>
                            </select>

                          </div>
                          <input
                            type="text"
                            className={`phone-input ${touched.mobileNo && errors.mobileNo ? 'is-invalid' : ''}`}
                            placeholder=""
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(/\D/g, '');
                              setFieldValue("mobileNo", numericValue);
                            }}
                            value={values.mobileNo}
                            maxLength="10"
                          />
                        </div>
                        {touched?.mobileNo && errors?.mobileNo ? (
                          <span style={{ fontSize: '14px', color: 'red' }}>{errors?.mobileNo}</span>
                        ) : ''}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Gender <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control selectpicker"
                          name="gender"
                          onChange={handleChange}
                          value={values.gender}
                        >
                          <option value="">Select </option>
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                          <option value="OTHERS">Others</option>
                        </select>
                        {touched?.gender && errors?.gender ? (
                          <span style={{ fontSize: '14px', color: 'red' }}>{errors?.gender}</span>
                        ) : ''}
                      </div>
                    </div>
                    <div className="col-md-6">
                   <div className="form-group">
                      <label>
                        Branch List <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control selectpicker"
                        name="shopId"
                        value={values.shopId}
                        onChange={handleChange}
                      >
                        <option value="">Select Branch</option>
                        {shopListing?.rows?.map((shop) => (
                          <option key={shop._id} value={shop._id}>
                            {shop.name}
                          </option>
                        ))}
                      </select>

                      {touched?.shopId && errors?.shopId && (
                        <span style={{ fontSize: '14px', color: 'red' }}>
                          {errors.shopId}
                        </span>
                      )}

                    </div>
                  </div>
                  {/* <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        National ID Number{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter National ID Number"
                      />
                    </div>
                  </div> */}
                    <div className="col-md-12">
                      <label>
                        Upload Documents
                      </label>
                      <table
                        className="table table-striped table-bordered admintable border-0"
                        cellSpacing="0"
                        cellPadding="0"
                      >
                        <tbody>
                          {values.documents?.map((doc, docIndex) => (
                            <div
                              key={docIndex}
                              className="card mb-2 shadow-sm rounded-3 position-relative"
                            >
                              <div className="card-body">
                                <div className="row aic">
                                  {/* Type */}
                                  <div className="col-md-4">
                                    <label className="label-input">Type</label>
                                    <input
                                      type="text"
                                      className="form-control login-input"
                                      placeholder="Certificate type"
                                      onChange={(e) => {
                                        const newDocs = [...values.documents];
                                        newDocs[docIndex].name = e.target.value;
                                        setFieldValue("documents", newDocs);
                                      }}
                                      value={doc.name}
                                    />
                                  </div>

                                  {/* Expiry */}
                                  <div className="col-md-4">
                                    <label className="label-input">Expiry</label>
                                    <input
                                      type="date"
                                      className="form-control login-input"
                                      min={new Date().toISOString().split("T")[0]}
                                      onChange={(e) => {
                                        const newDocs = [...values.documents];
                                        newDocs[docIndex].expiryDate = e.target.value;
                                        setFieldValue("documents", newDocs);
                                      }}
                                      
                                      value={doc.expiryDate}
                                    />
                                  </div>

                                  {/* Upload */}
                                  <div className="col-md-4">
                                    <label className="label-input">Document</label>
                                    <input
                                      type="file"
                                      id={`uploadDoc-${docIndex}`}
                                      className="d-none form-control"
                                      onChange={async (e) => {
                                        const [file] = e.target.files;
                                        if (!file) return;
                                        // File size check (2 MB max)
                                        const maxSize = 2 * 1024 * 1024;
                                        if (file.size > maxSize) {
                                          return showMessage({
                                            variant: _toastVariants.Error,
                                            message: "File size should not exceed 2 MB",
                                          });
                                        }
                                        const isValid = validateDocumentFileType(file.type);
                                        if (!isValid) {
                                          return showMessage({
                                            variant: _toastVariants.Error,
                                            message: "Unsupported file type",
                                          });
                                        }

                                        const newDocs = [...values.documents];
                                        newDocs[docIndex].attachments = [
                                          ...newDocs[docIndex].attachments,
                                          file,
                                        ];
                                        setFieldValue("documents", newDocs);
                                      }}
                                    />
                                    <label
                                      htmlFor={`uploadDoc-${docIndex}`}
                                      className="form-control login-input mb-0"
                                      style={{ cursor: "pointer" }}
                                    >
                                      + Add
                                    </label>
                                  </div>

                                  <div className="col-md-12">
                                    {/* Preview */}
                                    {doc.attachments.length > 0 && (
                                      <div className="row">
                                        <div className="col-md-12">
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "20px",
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            {doc.attachments.map((item, index) => (
                                              <div key={index} className="uploaddiv">
                                                <img
                                                  src={typeof item == "string" ? formatFileURL(item) : getFileUrl(item)}
                                                  className="uploadimages"
                                                  alt=""
                                                />
                                                <div
                                                  onClick={() => {
                                                    const newDocs = [
                                                      ...values.documents,
                                                    ];
                                                    newDocs[docIndex].attachments = newDocs[
                                                      docIndex
                                                    ].attachments.filter((_, i) => i !== index);
                                                    setFieldValue(
                                                      "documents",
                                                      newDocs
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src="/images/close.svg"
                                                    className="closeimg"
                                                    alt="remove"
                                                  />
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Cross Button */}
                                  <div>
                                    {docIndex !== 0 && (
                                      <span
                                        className="badge doc-c-btn"
                                        onClick={() => {
                                          const newDocs = values.documents.filter(
                                            (_, i) => i !== docIndex
                                          );
                                          setFieldValue("documents", newDocs);
                                        }}
                                      >
                                        X
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {touched?.documents && errors?.documents ? (
                                <span style={{ fontSize: '14px', color: 'red' }}>{errors?.documents}</span>
                              ) : ''}
                            </div>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-header" id="headingOne">
                  <h5 className="mb-0">
                    <button className="btn text-black shadow-none pl-0 pb-0 staturightghead">
                      Profile Picture
                    </button>
                  </h5>
                </div>

                <div className="card-body">

                  <div>

                    {/* Right Section */}
                    <CustomSelectFile
                      id="profilePic"
                      title={"Thumbnail (Jpeg,png,jpg)"}
                      onChange={(file) => setFieldValue("profilePic", file)}
                      files={values.profilePic}
                      error={Boolean(touched.profilePic && errors.profilePic)}
                      helperText={touched.profilePic && errors.profilePic}
                      imgSx={{ width: "100%", height: "auto" }}
                    />

                  </div>
                </div>
              </div>
              <div className="card mt-3">
                <div className="card-header" id="headingOne">
                  <h5 className="mb-0">
                    <button className="btn btn-link text-black shadow-none pl-0 pb-0 staturightghead">
                      Status Update
                    </button>
                  </h5>
                </div>
                <div className="card-body">
                  <div>
                    <label className="logCheck mb-3">
                      <input
                        type="radio"
                        checked={values.statusupdate === "ACTIVE"}
                        name="statusupdate"
                        onChange={handleChange}
                        value="ACTIVE"
                      />
                      <div>Active</div>
                      <span className="checkmark"></span>
                    </label>

                    <label className="logCheck mb-0">
                      <input
                        type="radio"
                        checked={values.statusupdate === "INACTIVE"}
                        name="statusupdate"
                        onChange={handleChange}
                        value="INACTIVE"
                      />
                      <div>Inactive</div>
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>

               <div className="card mt-3">
                  <h5 className="mt-2" style={{ marginLeft: "10px" }}>Is Delivery Associate</h5>
                    <label className="switch" style={{ marginLeft: "10px" }}>
                    <input
                      type="checkbox"
                      name="isDeliveryAssociate"
                      checked={values.isDeliveryAssociate}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setFieldValue("isDeliveryAssociate", checked);
                      }}
                    />
                      <span className="slider round"></span>
                    </label>

                    {values.isDeliveryAssociate && (
                      <>
                        <div className="card-header" style={{marginTop : "20px"}}>
                          <h5 className="mb-0">Delivery Associate Details</h5>
                        </div>
                        <div className="row">     
                          <div className="col-md-6 mt-3">
                            <div className="form-group">
                              <label>
                                Vehicle Number <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="vehicleRegNo"
                                placeholder="Enter Vehicle Number"
                                value={values.vehicleRegNo || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-6 mt-3">
                            <div className="form-group">
                              <label>
                                Driving Licence No <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="drivingLicense"
                                placeholder="Enter Licence Number"
                                value={values.drivingLicense || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                        </div>
                      </>
                    )}

                </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default AddEditStaff;
